var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.533,
    height: 21.669,
    viewBox: "0 0 24.533 21.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38316",
    "data-name": "Path 38316",
    d: "M23.031,3.88a5.054,5.054,0,0,0-2.618-2.592c-4.742-1.837-7.919,3.343-7.919,3.343S9.318-.549,4.576,1.288A5.054,5.054,0,0,0,1.958,3.88c-2.018,4.005-.713,9.408,2.651,11.4l7.885,5.6,7.885-5.6c3.364-1.993,4.669-7.4,2.651-11.4",
    transform: "translate(-0.228 -0.13)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistIcon);
export default __webpack_public_path__ + "static/media/wishlist-icon.f4cff27831def73eccfb6754a01c5136.svg";
export { ForwardRef as ReactComponent };